import script from "./HoverMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./HoverMenu.vue?vue&type=script&lang=ts&setup=true"

import "./HoverMenu.vue?vue&type=style&index=0&id=4aace004&lang=css"

const __exports__ = script;

export default __exports__